import React, { useEffect, useState } from 'react';

export default function Backtop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      id="back-to-top"
      className={`back-to-top${visible ? ' visible' : ''}`}
      title="Back to top"
      onClick={scrollToTop}
    >↑</button>
  );
}